module.exports = __webpack_public_path__ + "img/xg_code_1.ec089056.png";